module.exports = __webpack_public_path__ + "img/title_animated.02087988.svg";